import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { SettingsView } from '@/features/SettingsView';

export default function SettingsPage() {
    useDocumentTitle('settings');

    return <SettingsView />;
}
